import React from 'react';
import Icons, { IconNames } from './icons';
import { vessels } from '../data/vessels';
import { getVesselImage } from '../utils';

export default class VesselInfo extends React.Component {
  renderItem(label, info) {
    return (
      <div className="vessel__info__item">
        <div className="vessel__info__item__label">{label}</div>
        <div className="vessel__info__item__info">{info}</div>
      </div>
    );
  }

  onDialogClick(event) {
    event.stopPropagation();
  }

  render() {
    const vessel = vessels[this.props.vesselRef] || {};

    return (
      <div className="vesselInfo">
        <a href="javascript:void(0)">
          <Icons
            iconName={IconNames.Cancel}
            iconClassName="vessel__info__close__icon"
            className="vessel__info__close"
            onClick={this.props.onClose}
          />
        </a>
        <img
          className="vesselInfo__image"
          src={getVesselImage(this.props.vesselRef)}
          alt={vessel.name}
          onClick={this.onDialogClick}
        />
        <div className="vessel__info__wrapper" onClick={this.onDialogClick}>
          <div className="vessel__info__header">{vessel.name}</div>
          <div className="vessel__info__columns">
            <div className="vessel__info__column__left">
              {this.renderItem('Service', vessel.service)}
              {this.renderItem('IMO no.', vessel.imo_nr)}
              {this.renderItem('Type', vessel.type)}
              {this.renderItem('TEU', vessel.teu)}
              {this.renderItem('DWT', vessel.dwt)}
            </div>
            <div className="vessel__info__column__right">
              {this.renderItem('Service Speed', vessel.speed)}
              {this.renderItem('Year built', vessel.build_year)}
              {this.renderItem('Engine KW', vessel.engine_kw)}
              {this.renderItem('Length', vessel.length)}
              {this.renderItem('Draft', vessel.draft)}
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/vesselInfo.js